import { Col, Image, Row } from 'antd';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Typography, Button, ResponsiveContainer } from '@sunday/component';
import Layout from '../../components/Layout';
import { config } from '../../config';
import useQuery from '../../hooks/useQuery';
import style from './home.module.scss';
import cn from 'classnames';
import HomeAchievement from 'components/home/achievement/home-achievement';
import HomeHighlight from 'components/home/highlight/home-highlight';
import HomeProduct from 'components/home/product/home-product';
import HomeGeneralInsurance from 'components/home/general-insurance/home-generalInsurance';
import HomeInsurer from 'components/home/insurer/home-insurer';
import MarketingTypography from 'components/MarketingTypography/MarketingTypography';

const { ASSET_PREFIX } = config;
export const HomePageNameSpace = ['page.home'];

const Home = () => {
  const { t } = useTranslation(HomePageNameSpace);
  
  return (
    <Layout>
      <Row align='middle' gutter={24} className={style.heroBanner}>
        <Col xs={0} lg={24} style={{ height: '58px' }} />
        <Col xs={24} lg={0} style={{ height: '40px' }} />
        <Col xs={{ span: 20, offset: 2 }} sm={{ span: 10, offset: 4 }} lg={0} >
          <MarketingTypography.Display designLevel={3} weight='bold' className={style.white}>
            {t('tag-1')}<span className={cn(style.highlight)}>{t('tag-2')}</span> {t('tag-3')}
          </MarketingTypography.Display>
          <MarketingTypography.Title designLevel={2} weight='bold' className={style.white}>
            {t('headline-1')}
          </MarketingTypography.Title>
          <p/>
          <MarketingTypography.Title designLevel={3} className={style.white}>
            {t('headline-2')}
          </MarketingTypography.Title>
        </Col>
        <Col xs={0} sm={0} lg={{ span: 10, offset: 4 }} >
          <MarketingTypography.Display designLevel={2} weight='bold' className={style.white}>
            {t('tag-1')}<span className={cn(style.highlight)}>{t('tag-2')}</span> {t('tag-3')}
          </MarketingTypography.Display>
          <MarketingTypography.Title designLevel={1} weight='bold' className={style.white}>
            {t('headline-1')}
          </MarketingTypography.Title>
          <p/>
          <MarketingTypography.Title designLevel={3} className={style.white}>
            {t('headline-2')}
          </MarketingTypography.Title>
        </Col>
        <Col xs={{ span: 16, offset: 5 }} sm={{ span: 6 }} lg={{ span: 6, offset: 1 }} style={{ textAlign: 'center' }}>
          <Image
            src={`${ASSET_PREFIX}/static/img/img-hero-banner.png`}
            preview={false}
            alt="hero-banner"
          />
        </Col>
        <Col xs={0} lg={24} style={{ height: '58px' }} />
        <Col xs={24} lg={0} style={{ height: '40px' }} />
      </Row>

      <HomeAchievement />
      <HomeHighlight />
      <HomeProduct />
      <HomeGeneralInsurance />
      {
        /*
      <Row align="middle" gutter={24} className={style.talkToUs} >
        <Col xs={0} lg={12} >
          <ResponsiveContainer style={{ display: 'flex', flexDirection: 'column' }} className={style.container}>
            <MarketingTypography.Display designLevel={2} weight='bold' style={{ margin: "0" }}>
              <span className={style.white}>{t('talk-to-us-1')}</span> <span className={style.highlight}>{t('talk-to-us-2')}</span>
            </MarketingTypography.Display>
            <MarketingTypography.Title designLevel={3} className={style.white} >
              {t('talk-to-us-3')}
            </MarketingTypography.Title>
            <div style={{ width: "50%", marginTop: "40px" }}>
              <Button fullWidth size='m'>
                {t('talk-to-us-cta')}
              </Button>
            </div>
          </ResponsiveContainer>
        </Col>
        <Col xs={24} lg={0} >
          <ResponsiveContainer style={{ display: 'flex', flexDirection: 'column'  }} className={style.container}>
            <MarketingTypography.Display designLevel={3} weight='bold' style={{ margin: 0 }}>
              <span className={style.white}>{t('talk-to-us-1')}</span> <span className={style.highlight}>{t('talk-to-us-2')}</span>
            </MarketingTypography.Display>
            <MarketingTypography.Body designLevel={1} className={style.white} >
              {t('talk-to-us-3')}
            </MarketingTypography.Body>
            <div className={style.button}>
              <a href='/contact'>
                <Button fullWidth size='m'>
                  {t('talk-to-us-cta')}
                </Button>
              </a>
            </div>
          </ResponsiveContainer>
        </Col>
        <Col xs={24} lg={12} style={{display: 'flex', justifyContent: 'flex-end'}}>
          <Image
            src={`${ASSET_PREFIX}/static/img/img-talk-to-us.png`}
            preview={false}
            alt="talk-to-us"
          />
        </Col>
      </Row>
      */
      }
      <Row align="middle" gutter={24} className={style.talkToUs} >
          <Col xs={24} lg={12} style={{ display: "flex", justifyContent: "flex-end", padding: "0 32px" }}>
            <Image
              src={`${ASSET_PREFIX}/static/img/img-talk-to-us-2.svg`}
              preview={false}
              alt="talk-to-us"
            />
          </Col>
          <Col xs={0} lg={12}>
            <ResponsiveContainer style={{ display: 'flex', flexDirection: 'column', padding: "80px" }} className={style.container}>
              <MarketingTypography.Display designLevel={2} weight='bold' >
                <span className={style.white}>{t('talk-to-us-6')}</span> <span className={style.highlight}>{t('talk-to-us-7')}</span> <span className={style.white} >{t('talk-to-us-8')}</span>
              </MarketingTypography.Display>
              <MarketingTypography.Title designLevel={3} className={style.white} >
                {t('talk-to-us-9')}
              </MarketingTypography.Title>
              <div className={style.button}>
                <a href='/contact'>
                  <Button fullWidth size='m'>
                    {t('talk-to-us-cta')}
                  </Button>
                </a>
              </div>
            </ResponsiveContainer>
          </Col>
          <Col xs={24} lg={0}>
            <ResponsiveContainer style={{ display: 'flex', flexDirection: 'column' }} className={style.container}>
              <MarketingTypography.Display designLevel={3} weight='bold' >
                <span className={style.white}>{t('talk-to-us-6')}</span> <span className={style.highlight}>{t('talk-to-us-7')}</span> <span className={style.white} >{t('talk-to-us-8')}</span>
              </MarketingTypography.Display>
              <MarketingTypography.Body designLevel={1} className={style.white} >
                {t('talk-to-us-9')}
              </MarketingTypography.Body>
              <div className={style.button}>
                <a href='/contact'>
                  <Button fullWidth size='m'>
                    {t('talk-to-us-cta')}
                  </Button>
                </a>
              </div>
            </ResponsiveContainer>
          </Col>
        
      </Row>

    </Layout>
  );
};

export default Home;
